import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/student/Button";
import { Modal } from "../Modal";
import * as s from "./ConflictModal.sss";
export const ConflictModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { withClose: true, className: s.conflictModal, isOpen: isOpen, onRequestClose: onClose },
        React.createElement("div", { className: s.conflictModalContent },
            React.createElement("p", { className: s.title }, t("student~Ви вже додали заняття на цей час")),
            React.createElement("p", null, t("student~Оберіть інший час або день")),
            React.createElement("div", null,
                React.createElement(Button, { className: s.button, onClick: onClose }, t("student~Закрити"))))));
};
